<template>
  <div class="dep-description">
    <info-block :title="$t('labels.description')"
                marker-color="#FF8989"
                :footer-text="date">
      <div class="dep-description__container">
        <template v-if="description">
          <div v-if="description.length > excerptLength && !visibleExcerpt"
            class="dep-description__excerpt">
            <span>{{description | truncate(excerptLength)}}</span>
          </div>
          <div v-if="description.length < excerptLength || visibleExcerpt"
               class="dep-description__text">
            <span>{{ description }}</span>
          </div>
          <div class="dep-description__more-link" v-if="description.length > excerptLength">
            <span @click="visibleExcerpt = !visibleExcerpt" v-if="!visibleExcerpt">{{ $t('labels.more') }}</span>
            <span @click="visibleExcerpt = !visibleExcerpt" v-if="visibleExcerpt">{{ $t('labels.hide') }}</span>
          </div>
        </template>
        <div v-else class="dep-description__text">{{ $t('labels.not_specified') }}</div>
      </div>
    </info-block>
  </div>
</template>
<script>
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'

  export default {
    props: ['description', 'date'],
    components: {
      infoBlock
    },
    data () {
      return {
        visibleExcerpt: false,
        excerptLength: 180
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.dep-description {
  &:before {
    background: #FF8989;
  }

  &__container {
    position: relative;
  }

  &__text {
    position: relative;
    white-space: pre-line;
    word-break: break-word;
  }

  &__excerpt {
    white-space: initial;
  }

  &__more-link {
    text-align: right;
    padding-top: 10px;
    span {
      color: $link-color;
      cursor: pointer;
      &:hover {
        color: $link-color-hover;
      }
    }
  }
}
</style>